<template>
  <b-row>
    <b-col cols="12">
      <tabela-repeticao
        v-model="cnaeSecundarios"
        :colunas="cnaeColunas"
        :validar="validar"
        class="tabela-cnae"
      >
        <template #visualizacao="{slotScope: {valor}}">
          {{ valor }}
        </template>

        <template #edicao="{slotScope: {item, key}}">
          <b-input
            v-model="item[key]"
            :disabled="key==='descricao'"
            :class="{'is-invalid' : item.erro && item.erro[key]}"
            @blur="buscarDescricao(item, key)"
          />
        </template>
      </tabela-repeticao>
    </b-col>
  </b-row>
</template>

<style lang="scss">
td.ie-select {
  max-width: 8rem !important;
}

.tabela-cnae tbody tr td:first-child{
  width: 14rem;
}
</style>

<script>
import { mapGetters } from 'vuex'
import api from '../cnae/api'

export default {
  name: 'CNAETabela',
  components: {
    TabelaRepeticao: () => import('@/shared/components/tabela-repeticao/TabelaRepeticao.vue'),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cnaeColunas: [
        { key: 'idIBGE', label: 'Código CNAE' },
        { key: 'descricao', label: 'Descrição' },
      ],
    }
  },
  computed: {
    ...mapGetters('empresa', ['cnaeSecundarios']),
  },
  methods: {
    buscarDescricao(item, key) {
      if (key === 'idIBGE' && item.idIBGE) {
        api.buscarCNAE(item.idIBGE)
          .then(payload => {
            const desc = payload.data.length === 0 ? null : payload.data[0].descricao
            this.$set(item, 'erro', {})
            if (!desc) {
              this.$set(item.erro, key, true)
            } else {
              this.$set(item.erro, key, false)
              this.$set(item, 'descricao', desc)
            }
          })
          .catch(err => {
            throw err
          })
      }
    },
    validar(item) {
      this.$set(item, 'erro', {})

      if (!item.idIBGE) {
        this.$set(item.erro, 'idIBGE', true)
        return false
      }
      return true
    },
  },
}
</script>
